import { useTranslation } from "react-i18next";
import { useAuth0 } from "@auth0/auth0-react";
import logo from "../../assets/img/starlight-logo.svg";
import UiButton from "../../components/button/Button";
import { PageProps } from "../../models/routing.model";
import { deleteSession } from "../../services/session/auth.service";
import { useState } from "react";
import { MessageSeverity } from "../../models/components/field-message.model";
import UiMessage from "../../components/message/Message.component";
import { ThemeService } from "../../services/theme/ThemeService.service";

const Login = (_props: PageProps) => {
	const { t } = useTranslation("common");
	const { loginWithRedirect } = useAuth0();
	const [isRedirectingToAuth0, setIsRedirectingToAuth0] = useState(false);

	const getLoginError = () => {
		const errorType = new URLSearchParams(window.location.search).get("errorType");

		const errors: { [type: string]: string } = {
			unauthorized_to_signin: "LOGIN.ERROR.UNAUTHORIZED_TO_SIGNIN",
			session_expired: "LOGIN.ERROR.SESSION_EXPIRED",
		};

		if (!errorType) {
			return null;
		}

		return errors[errorType] ?? "UI_COMPONENTS.MESSAGE.HTTP.ERROR";
	};

	const error = getLoginError();

	// When the login page loads, reset the old session
	deleteSession();

	/**
	 * Theme:
	 * Since the user still hasn't logged in, and we don't know his brand identity, we will set the theme based on the domain
	 */
	ThemeService.setTheme();

	return (
		<div className="login__page-layout">
			<div className="login__form-layout">
				<div className="login__welcome-container">
					<img
						className="login__welcome-image"
						src={ThemeService.setLoginLogo()}
						alt={"company logo"}
					/>
					<h2 className="login__welcome-title">{t("LOGIN.TITLE")}</h2>
					<p className="login__welcome-support">
						{t("LOGIN.SUPPORT")}
						<a
							href=""
							onClick={() =>
								(window.location.href = `mailto:${ThemeService.setSupportEmail()}`)
							}
						>
							{ThemeService.setSupportEmail()}
						</a>
					</p>
				</div>

				{error && (
					<div className="login__error">
						<UiMessage
							severity={MessageSeverity.DANGER}
							label={error}
						/>
					</div>
				)}

				<UiButton
					id="signinButton"
					testId="signinButton"
					label={isRedirectingToAuth0 ? "LOGIN.BUTTON_SIGNING_IN" : "LOGIN.BUTTON_SIGNIN"}
					className="p-button-lg"
					onClick={() => {
						setIsRedirectingToAuth0(true);
						loginWithRedirect();
					}}
					loading={isRedirectingToAuth0}
					disabled={isRedirectingToAuth0}
				/>
			</div>
		</div>
	);
};
export default Login;
